import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleArticleLike } from '../reducers/likes';
import { getArticleTotalLikes, getInitUserLikes, getIsArticleLikedByCurrentUser } from '../selectors/likes';

export function useIsArticleLikedByCurrentUser(articleId): boolean | undefined {
  return useSelector(getIsArticleLikedByCurrentUser(articleId));
}

export function useArticleTotalLikes(articleId): number | undefined {
  return useSelector(getArticleTotalLikes(articleId));
}

export const useArticleLikes = (articleId) => {
  const isArticleLiked = useIsArticleLikedByCurrentUser(articleId);
  const likesCount = useArticleTotalLikes(articleId);
  const dispatch = useDispatch();
  const toggleLike = useCallback(
    async (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();

      await dispatch(toggleArticleLike(articleId, isArticleLiked));
    },
    [dispatch, articleId, isArticleLiked],
  );

  return { toggleLike, likesCount, isArticleLiked };
};

export const useInitUserLikes = () => useSelector(getInitUserLikes) || {};
